import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbCalendar, NgbDate, NgbTimeStruct, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { Utils } from 'app/components/utils/Utils';
import { ParameterCart } from 'app/models/cart-model';
import { StockModel } from 'app/models/stock-model';
import { AppService } from 'app/services/app/app.service';
import { EventsService } from 'app/services/events/events.service';
import moment from 'moment-timezone';
import { Subscription } from 'rxjs';
import { SharedModule } from 'app/shared.module';
import { Log } from 'app/core/logging/log';


type ActiveSection = 'reservation' | 'subscription';
type ReservationMode = 'range' | 'duration';
type SubscriptionPlan = 'monthly' | 'weekly';

@Component({
    selector: 'app-block-date',
    templateUrl: './block-date.component.html',
    styleUrls: ['./block-date.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SharedModule, NgbDatepickerModule]
})
export class BlockDateComponent implements OnInit {
    DIFF_DAYS_DEFAUL = 0;
    MAX_DAYS_FUTURE = 90;

    parameters: ParameterCart;
    hoveredDate: NgbDate | null = null;
    fromDate: NgbDate;
    toDate: NgbDate | null = null;
    fromTime: NgbTimeStruct | null = null
    toTime: NgbTimeStruct | null = null
    minDate: NgbDate | null = null;
    maxDate: NgbDate | null = null;
    @Input() showDetail: boolean = false;
    @Input() minPrice: number = 0;
    @Input() maxPeriod: number = this.MAX_DAYS_FUTURE;
    @Input() minPeriod: number = 0;
    @Output() callBack = new EventEmitter<any>();
    modeSelect: boolean = true;
    TIME_ZONE_LOCAL: string = "Europe/Madrid"; //Europe/Madrid
    fromTimeOptions: string[] = [];
    toTimeOptions: string[] = [];
    hasTime: boolean = true;
    currentStock$: Subscription;
    openingHours: string;
    closingHours: string;
    openingHoursUtc: string;
    closingHoursUtc: string;
    tz: string;
    mode: string;

    totalPeriodInitial = 0;

    //
    @Input() subscriptions: any;
    @Input() activeSection: ActiveSection = 'reservation';
    reservationMode: ReservationMode = 'range';
    selectedPlan: SubscriptionPlan = 'monthly';

    today: Date = new Date();
    startDate: Date | null = new Date();
    endDate: Date | null;

    durationDays = 1;
    computedEndDate: Date;

    reservationPrice = 1;
    reservationSummaryLabel = '';

    durationLabel = '';
    fromDateTimeLabel = '';
    toDateTimeLabel = '';
    nextChargeLabel = '';

    constructor(
        private route: ActivatedRoute,
        public calendar: NgbCalendar,
        public formatter: NgbDateParserFormatter,
        private eventsService: EventsService,
        private appService: AppService
    ) {

        this.reservationSummaryLabel = `1 ${this.appService.getTraduccion('day')}`;
        this.parameters = Utils.getParams(this.route.snapshot.queryParamMap);

        this.currentStock$ = this.appService.currentStock$.subscribe((stock: StockModel) => {
            this.tz = stock.tz;
            this.openingHoursUtc = stock.openingHours;
            this.closingHoursUtc = stock.closingHours;

            let now = this.getNow();
            let to = this.getNow();
            let future = this.getNow().add(this.maxPeriod, 'd');

            this.mode = Utils.getMode(stock, this.parameters);

            if (this.mode == 'KEY') {
                this.modeSelect = false;
                this.hasTime = false;
                to.add(1, 'd');

                this.minDate = this.momentToNgbDateMap(now);
                this.maxDate = this.momentToNgbDateMap(future);
                this.fromDate = this.momentToNgbDateMap(now);
                this.toDate = this.momentToNgbDateMap(to);

                this.fromTime = this.mapperToNgbTimeStruct(this.getNow());
                this.toTime = this.mapperToNgbTimeStruct(this.getNow());

            } else {
                const today = this.momentToNgbDateMap(now);
                const todayClosing = this.getLocalTimeFromUtcHours(today, this.closingHoursUtc);
                const lastStartToday = todayClosing.clone().subtract(1, 'hours');

                this.openingHours = this.getLocalTimeFromUtcHours(today, this.openingHoursUtc).format('HH:mm');
                this.closingHours = todayClosing.format('HH:mm');

                if (now.isAfter(lastStartToday)) {
                    now.add(1, 'd');
                    to.add(1, 'd');
                    future.add(1, 'd');
                }

                this.minDate = this.momentToNgbDateMap(now);
                this.maxDate = this.momentToNgbDateMap(future);
                this.fromDate = this.momentToNgbDateMap(now);
                this.toDate = this.momentToNgbDateMap(to);

                this.configureTimeOptions(true);
            }

            this.totalPeriodInitial = this.totalPeriod;
            setTimeout(() => this.updateCart(), 100);
        });

    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.eventsService.destroy('callNext');
        this.currentStock$.unsubscribe();
    }

    /**
     * un dia:
        - today: 
            - rango de inicio: horaActual...horaCierreMenosInterval
            - rango de finalizacion: horaInicioMasPeriod...horaCierre
	
        - notoday:
            - rango de inicio: horaApertura...horaCierreMenosInterval
            - rango de finalizacion: horaInicioMasPeriod...horaCierre

    * varios día:
        - rango de inicio: horaApertura...horaCierreMenosInterval
        - rango de finalización: horaInicioMasPeriod...horaCierre

     * @param reset 
     */
    configureTimeOptions(reset: boolean | null = false) {
        const minPeriod = 1;
        const interval = 60;

        let now: moment.Moment = this.getNow();
        let startStartRange: moment.Moment = this.getLocalTimeFromUtcHours(this.fromDate, this.openingHoursUtc);
        let endStartRange: moment.Moment = this.getLocalTimeFromUtcHours(this.fromDate, this.closingHoursUtc);
        let startEndRange: moment.Moment = this.getLocalTimeFromUtcHours(this.toDate || this.fromDate, this.openingHoursUtc);
        let endEndRange: moment.Moment = this.getLocalTimeFromUtcHours(this.toDate || this.fromDate, this.closingHoursUtc);

        this.openingHours = startStartRange.format('HH:mm');
        this.closingHours = endStartRange.format('HH:mm');

        //--------------- Start Range ------------------//
        let isOneDay: boolean = this.fromDate.equals(this.toDate);
        let isToday: boolean = this.fromDate.equals(this.momentToNgbDateMap(now));
        if (isToday && now.isAfter(startStartRange)) {
            startStartRange.set('hours', now.hours());
            startStartRange.set('minutes', now.minutes());
        }

        if (isOneDay) {
            endStartRange.subtract(minPeriod, 'hours');
        } else {
            endStartRange.subtract(interval, 'minutes');
        }


        //--------------- End Range ------------------//

        if (isOneDay) {
            startEndRange = startStartRange.clone();
            if (this.fromTime != null && !reset) {
                startEndRange.set('hours', this.fromTime.hour);
                startEndRange.set('minutes', this.fromTime.minute);
            }
            startEndRange.add(minPeriod, 'hours');
        } else {
            //  startEndRange.add(interval, 'minutes');
        }

        //  console.log('isOneDay:'+isOneDay);
        //   console.log('isToday:'+isToday)
        //   console.log(startStartRange.format('HH:mm'), endStartRange.format('HH:mm'), startEndRange.format('HH:mm'), endEndRange.format('HH:mm'));

        this.fromTimeOptions = this.generateRangeHours(startStartRange.format('HH:mm'), endStartRange.format('HH:mm'), interval);
        this.toTimeOptions = this.generateRangeHours(startEndRange.format('HH:mm'), endEndRange.format('HH:mm'), interval, null, false);

        if (reset) {
            if (this.fromTimeOptions.length > 0) {
                this.fromTime = this.mapStringTimeToNgbTimeStruct(this.fromTimeOptions[0]);
            }
            if (this.toTimeOptions.length > 0) {
                this.toTime = this.mapStringTimeToNgbTimeStruct(this.toTimeOptions[0])
            }
        }
    }


    momentToNgbDateMap(moment: moment.Moment): NgbDate {
        return new NgbDate(
            moment.year(),
            moment.month() + 1,
            moment.date()
        )
    }

    formatDate(date: NgbDate) {
        if (date == undefined) {
            return "";
        }
        return date.day + '-' + date.month + '-' + date.year;
    }

    formatDateTime(datetime: moment.Moment) {
        if (datetime == undefined) {
            return "";
        }
        return datetime.format('DD-MM-YYYY HH:mm')
    }

    mapperToNgbTimeStruct(datetime: moment.Moment): NgbTimeStruct {
        if (datetime == undefined) {
            return null;
        }
        return {
            hour: datetime.hours(),
            minute: datetime.minutes(),
            second: 0
        }
    }

    convertTimezone(date: NgbDate, time: NgbTimeStruct): moment.Moment {
        return moment.tz({
            year: date.year,
            month: date.month - 1,
            date: date.day,
            hour: time.hour,
            minute: time.minute,
            second: 0,
            millisecond: 0
        }, this.getCurrentTimezone()).utc();
    }


    formatDateWithCurrentTime(date: NgbDate, time: NgbTimeStruct) {
        if (date == undefined) {
            return "";
        }
        if (time == undefined) {
            return "";
        }
        let timeStr = `${String(time.hour).padStart(2, '0')}:${String(time.minute).padStart(2, '0')}`
        return date.day + '-' + date.month + '-' + date.year + ' ' + timeStr;
    }



    onDateSelection(date: NgbDate, datepicker: any) {
        this.parameters.paymentFrequency = "UNIQUE";
        if (!this.fromDate && !this.toDate) {
            this.fromDate = date;
        } else if (this.fromDate && !this.toDate && date && (date.after(this.fromDate) || date.equals(this.fromDate))) {
            this.toDate = date;
            datepicker.toggle();
            this.configureTimeOptions(true);
            this.updateCart('reservation');
        } else {
            this.toDate = null;
            this.fromDate = date;
        }
    }

    onClickSubscription(subscription:any){
        this.parameters.paymentFrequency = "RECURRENT";
        this.updateCart('subscription');
        
        this.nextChargeLabel = this.formatDateTime(this.getNow().add(subscription.period, 'days'));
    }

    isMinDate(date: NgbDate) {
        return (
            !date.equals(this.minDate) && !date.after(this.minDate)
        );
    }

    isMaxDate(date: NgbDate) {
        return (
            !date.before(this.maxDate)
        );
    }

    isHovered(date: NgbDate) {
        return (
            this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
        );
    }

    isInside(date: NgbDate) {
        return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
    }

    isRange(date: NgbDate) {
        return (
            date.equals(this.fromDate) ||
            (this.toDate && date.equals(this.toDate)) ||
            this.isInside(date) ||
            this.isHovered(date)
        );
    }

    validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
        const parsed = this.formatter.parse(input);
        return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
    }

    validateInputTime(currentValue: NgbTimeStruct | null, input: string): NgbTimeStruct | null {
        const parsed = this.formatter.parse(input);
        return currentValue;
    }

    activate(section: ActiveSection) {
        if (section === 'reservation') {
            this.parameters.paymentFrequency = 'UNIQUE';
        }

        this.updateCart(section);
    }

    getDiffDays() {
        let dayFix = 0;
        if (this.mode == 'KEY') {
            dayFix = 1;
        }
        if (this.toDate == undefined || this.fromDate == undefined) {
            return 0 + dayFix;
        }
        let a = moment([this.toDate.year, this.toDate.month - 1, this.toDate.day]);
        let b = moment([this.fromDate.year, this.fromDate.month - 1, this.fromDate.day]);
        return (a.diff(b, 'days')) + dayFix;
    }

    get totalPeriod():number {
        let dayFix = 0;
        //if (this.mode == 'KEY') {
           // dayFix = 1;
        //}
        if (this.toDate == undefined || this.fromDate == undefined) {
            return 0 + dayFix;
        }
        let a = moment([this.toDate.year, this.toDate.month - 1, this.toDate.day]);
        let b = moment([this.fromDate.year, this.fromDate.month - 1, this.fromDate.day]);

        let result:number = (a.diff(b, 'hours')) + dayFix;
        return Math.abs(result);
    }

    getDuration() {

        if (this.toDate == undefined || this.fromDate == undefined) {
            return;
        }
        if (this.fromTime == undefined || this.toTime == undefined) {
            return;
        }

        let start = moment([this.fromDate.year, this.fromDate.month - 1, this.fromDate.day, this.fromTime.hour, this.fromTime.minute]);
        let end = moment([this.toDate.year, this.toDate.month - 1, this.toDate.day, this.toTime.hour, this.toTime.minute]);

        let duration = moment.duration(end.diff(start));
        let d = Math.floor(duration.asDays());
        let h = duration.hours();
        let m = duration.minutes();

        let days = this.appService.getTraduccion('days');
        let hours = this.appService.getTraduccion('hours');
        let minutes = this.appService.getTraduccion('minutes');
        let day = this.appService.getTraduccion('day');
        let hour = this.appService.getTraduccion('hour');
        let minute = this.appService.getTraduccion('minute');

        //console.log(start.toDate(), end.toDate());

        let daySrt = (d > 0) ? (d + ' ' + (d > 1 ? days : day)) : '';
        let hourSrt = (h > 0) ? (h + ' ' + (h > 1 ? hours : hour)) : '';
        let minuteSrt = (m > 0) ? (m + ' ' + (m > 1 ? minutes : minute)) : '';

        //9 días, 6 horas 55 minutos
        return daySrt + ' ' + hourSrt + ' ' + minuteSrt;
    }

    plus() {
        let a = moment([this.toDate.year, this.toDate.month - 1, this.toDate.day]);
        a.add(1, 'days');
        this.toDate = new NgbDate(
            a.year(),
            a.month() + 1,
            a.date()
        );
        this.updateCart('reservation');
    }

    less() {
        var a = moment([this.toDate.year, this.toDate.month - 1, this.toDate.day]);
        a.subtract(1, 'days');
        this.toDate = new NgbDate(
            a.year(),
            a.month() + 1,
            a.date()
        );
        this.updateCart('reservation');
    }

    onChangeFromTime($event) {
        let value: string = $event.target.value;
        this.fromTime = this.mapStringTimeToNgbTimeStruct(value);
        this.configureTimeOptions();
        let eventToTime = {
            target: { value: this.toTimeOptions[0] }
        }
        this.onChangeToTime(eventToTime);
        //console.log('this.fromTime', this.fromTime, value);
    }

    onChangeToTime($event) {
        let value: string = $event.target.value;
        this.toTime = this.mapStringTimeToNgbTimeStruct(value);
        this.updateCart('reservation');
    }

    generateRangeHours(horaInicio: string, horaFin: string, intervalo: number = 15, limiteHoras?: number, fixedInterval: boolean = true): string[] {
        const [hInicio, mInicio] = horaInicio.split(':').map(Number);
        const [hFin, mFin] = horaFin.split(':').map(Number);

        const inicio = new Date();
        inicio.setHours(hInicio, mInicio, 0, 0);

        const fin = new Date();
        fin.setHours(hFin, mFin, 0, 0);

        const resultado: string[] = [];

        // Agregar la hora de inicio exacta
        resultado.push(inicio.toTimeString().slice(0, 5));

        // Siguiente múltiplo de intervalo alineado a :00, :15, :30, :45
        const siguiente = new Date(inicio);
        const minutos = siguiente.getMinutes();
        const offset = intervalo - (fixedInterval ? (minutos % intervalo) : 0);
        siguiente.setMinutes(minutos + offset);

        // Calcular el tope por limiteHoras (sin impedir incluir horaFin)
        const limite = limiteHoras
            ? new Date(inicio.getTime() + limiteHoras * 60 * 60 * 1000)
            : null;

        // Avanzar hasta llegar al límite (si hay) o a la hora de fin (lo que venga primero)
        while (!limite || siguiente <= limite) {
            // Detener si ya pasó la hora fin
            if (siguiente >= fin) break;
            resultado.push(siguiente.toTimeString().slice(0, 5));
            siguiente.setMinutes(siguiente.getMinutes() + intervalo);
        }

        // Asegurarse de incluir siempre la hora de fin
        const horaFinStr = fin.toTimeString().slice(0, 5);
        if (!resultado.includes(horaFinStr)) {
            resultado.push(horaFinStr);
        }

        return resultado;
    }

    mapStringTimeToNgbTimeStruct(input: string): NgbTimeStruct {
        let hours: number = Number(input.split(':')[0]);
        let minutes: number = Number(input.split(':')[1]);
        return {
            hour: hours,
            minute: minutes,
            second: 0
        }
    }

    updateCart(caller?:ActiveSection) {
        // console.log('cart updated');
        //this.parameters = Utils.getParams(this.route.snapshot.queryParamMap);
        this.durationLabel = this.getDuration() || '';
        this.fromDateTimeLabel = this.formatDateWithCurrentTime(this.fromDate, this.fromTime);
        this.toDateTimeLabel = this.formatDateWithCurrentTime(this.toDate, this.toTime);
        this.parameters.startDate = this.formatDateTime(this.convertTimezone(this.fromDate, this.fromTime));
        this.parameters.endDate = this.formatDateTime(this.convertTimezone(this.toDate, this.toTime));
        //this.parameters.paymentFrequency = caller;

        this.callBack.emit({parameters:this.parameters, caller: caller});
    }

    private getNow(): moment.Moment {
        const now = moment.tz(this.getCurrentTimezone());
        now.locale("es");
        //now.set('hour', 2); //TODO probar diferentes horas
        return now;
    }

    private getCurrentTimezone(): string {
        return this.tz || this.TIME_ZONE_LOCAL;
    }

    private getLocalTimeFromUtcHours(date: NgbDate, time: string): moment.Moment {
        const [hour, minute] = time.split(':').map(value => Number(value.trim()));
        return moment.utc({
            year: date.year,
            month: date.month - 1,
            date: date.day,
            hour,
            minute,
            second: 0,
            millisecond: 0
        }).tz(this.getCurrentTimezone());
    }

}
